import React, { createContext, useState } from 'react';
import en from '../i18n/en.json';
import es from '../i18n/es.json';

export const LanguageContext = createContext();

const translations = {
  en,
  es
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
